<template>
  <b-modal
    :visible="visible"
    :title="$t('dispatcher.order-request.review.accept.title')"
    hide-footer
    @hide="handleClose"
  >
    <b-form-group :label="$t('dispatcher.order-request.review.accept.comment-label')">
      <b-form-textarea
        v-model="form.comment"
        rows="3"
        max-rows="6"
        :disabled="loading"
      />
    </b-form-group>

    <div class="d-flex justify-content-end gap-1">
      <b-button
        variant="outline-secondary"
        :disabled="loading"
        @click="handleClose"
      >
        {{ $t('shared.button.cancel') }}
      </b-button>
      <b-button
        variant="success"
        :disabled="loading"
        @click="submit"
      >
        {{ $t('dispatcher.order-request.review.actions.accept') }}
      </b-button>
    </div>
  </b-modal>
</template>

<script>
import {
  BButton,
  BFormGroup,
  BFormTextarea,
  BModal,
} from 'bootstrap-vue'
import { buildAcceptPayload, createEmptyAcceptForm } from '../helpers/reviewFormModel'

export default {
  name: 'DispatcherReviewAcceptModal',
  components: {
    BButton,
    BFormGroup,
    BFormTextarea,
    BModal,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: createEmptyAcceptForm(),
    }
  },
  watch: {
    visible(isVisible) {
      if (isVisible) {
        this.resetForm()
      }
    },
  },
  methods: {
    submit() {
      this.$emit('confirm', buildAcceptPayload(this.form))
    },
    handleClose() {
      this.$emit('close')
    },
    resetForm() {
      this.form = createEmptyAcceptForm()
    },
  },
}
</script>

<style scoped lang="scss">
.gap-1 {
  gap: 0.5rem;
}
</style>
